import gql from 'graphql-tag';

export const GET_LOCATION_ENVIRONMENT_MAINTENANCES_QUERY = gql`
  query QueryLocationEnvironmentGQL($id:ID!, $take: Int, $after: String) {
    locationEnvironment(id: $id) {
      id
      locationSector {
        id
        location {
          id
        }
      }
      maintenances (take: $take, after: $after) {
        pageInfo {
          startCursor
          endCursor
        }
        items {
          id
          number
          status
          openedAt
          firstVisitStartedAt
          scheduled {
            date
            time
          }
          company {
            id
            name
            avatarUrl
          }
          maintenanceType {
            id
            name
          }
        }
      }
    }
  }
`;
